import React from 'react';
import {LauncherComponentBase} from '../../../base-components/launcher-component-base';

import PlayCircleFilled from '@material-ui/icons/PlayCircleFilled';
import {AppBarButtonComponent} from '../app-bar-button/app-bar-button.component';
import {observer} from 'mobx-react';

@observer
export class StartOrbitButtonComponent extends LauncherComponentBase<{}> {

    _startOrbit = () => {
        this.services.configsStorage.save();
        this.services.location.redirect(this.services.location.currentUri.origin);
    };

    render() {
        return (
            <AppBarButtonComponent text='Save & Launch Orbit' onClick={this._startOrbit}>
                <PlayCircleFilled/>
            </AppBarButtonComponent>
        )
    }
}